import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, PlusIcon, SendIcon, BarChart4Icon, TagIcon } from 'lucide-react';
import { AccountSummary } from './AccountSummary';
import { TransactionList } from './TransactionList';
import { UpcomingPayments } from './UpcomingPayments';
import { CharityDonationSection } from './CharityDonationSection';
interface DashboardProps {
  selectedPaymentId?: string | null;
  onPaymentManaged?: () => void;
  onCardShipped?: () => void;
}
export function Dashboard({
  selectedPaymentId,
  onPaymentManaged,
  onCardShipped
}: DashboardProps) {
  // Mock monthly payments data - this should match the UpcomingPayments data
  const monthlyPayments = [{
    id: '1',
    name: 'Rent',
    amount: 850.0,
    dueDate: '2024-06-01',
    status: 'pending' as const,
    category: 'Housing',
    recurring: true
  }, {
    id: '2',
    name: 'Utilities',
    amount: 120.0,
    dueDate: '2024-06-05',
    status: 'pending' as const,
    category: 'Bills',
    recurring: true
  }, {
    id: '3',
    name: 'Phone Bill',
    amount: 45.0,
    dueDate: '2024-06-10',
    status: 'paid' as const,
    category: 'Bills',
    recurring: true
  }, {
    id: '4',
    name: 'Gym Membership',
    amount: 35.0,
    dueDate: '2024-06-15',
    status: 'pending' as const,
    category: 'Health',
    recurring: true
  }, {
    id: '5',
    name: 'Streaming Services',
    amount: 25.0,
    dueDate: '2024-06-20',
    status: 'pending' as const,
    category: 'Entertainment',
    recurring: true
  }, {
    id: '6',
    name: 'Groceries',
    amount: 280.0,
    dueDate: '2024-06-03',
    status: 'pending' as const,
    category: 'Food',
    recurring: true
  }, {
    id: '7',
    name: 'Transport',
    amount: 95.0,
    dueDate: '2024-06-01',
    status: 'pending' as const,
    category: 'Transport',
    recurring: true
  }, {
    id: '8',
    name: 'Student Loan',
    amount: 187.96,
    dueDate: '2024-06-25',
    status: 'pending' as const,
    category: 'Education',
    recurring: true
  }, {
    id: '9',
    name: 'Insurance',
    amount: 50.0,
    dueDate: '2024-06-12',
    status: 'pending' as const,
    category: 'Insurance',
    recurring: true
  }];
  return <div className="space-y-6" data-id="element-313">
      <AccountSummary monthlyPayments={monthlyPayments} onCardShipped={onCardShipped} data-id="element-314" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-315">
        <div className="md:col-span-2 space-y-6" data-id="element-316">
          <TransactionList data-id="element-317" />
        </div>
        <div className="space-y-6" data-id="element-318">
          <UpcomingPayments selectedPaymentId={selectedPaymentId} onPaymentManaged={onPaymentManaged} data-id="element-319" />
          <div className="bg-card rounded-xl p-4 shadow-sm" data-id="element-320">
            <h2 className="text-lg font-semibold mb-3 text-text-primary" data-id="element-321">
              Financial Insights
            </h2>
            <div className="space-y-3" data-id="element-322">
              <div className="flex items-center p-3 bg-primary/5 rounded-lg" data-id="element-323">
                <BarChart4Icon className="w-5 h-5 text-primary mr-3" data-id="element-324" />
                <div data-id="element-325">
                  <p className="text-sm font-medium text-text-primary" data-id="element-326">
                    Spending increased
                  </p>
                  <p className="text-xs text-text-secondary" data-id="element-327">
                    15% more than last month
                  </p>
                </div>
              </div>
              <div className="flex items-center p-3 bg-secondary/5 rounded-lg" data-id="element-328">
                <TagIcon className="w-5 h-5 text-secondary mr-3" data-id="element-329" />
                <div data-id="element-330">
                  <p className="text-sm font-medium text-text-primary" data-id="element-331">
                    Shopping category
                  </p>
                  <p className="text-xs text-text-secondary" data-id="element-332">
                    Highest expense this month
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Charity Donation Section */}
      <CharityDonationSection data-id="element-333" />
    </div>;
}